import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Landing from "./pages/Landing";
import AdminDashboard from "./pages/AdminDashboard";
import AdminTeslaFleet from "./pages/AdminTeslaFleet";
import ConnectPage from "./pages/ConnectPage";
import VinLookupPage from "./pages/VinLookupPage";
import ReviewsPage from "./pages/ReviewsPage";
import NotFoundPage from "./pages/NotFoundPage";
import ComparisonPage from "./pages/ComparisonPage";
import BlogPage from "./pages/BlogPage";
import BlogPostPage from "./pages/BlogPostPage";
import AdminBlogPage from "./pages/AdminBlogPage";
import MobileApp from "./pages/MobileApp";
import { WelcomeGate } from "./components/WelcomeGate";
import { TeslaConnectBanner } from "./components/TeslaConnectBanner";
import PrivacyPolicy from "./pages/legal/PrivacyPolicy";
import TermsOfService from "./pages/legal/TermsOfService";
import Contact from "./pages/legal/Contact";
import About from "./pages/legal/About";
import Security from "./pages/legal/Security";
import CookiePolicy from "./pages/legal/CookiePolicy";
import WhyEviq from "./pages/legal/WhyEviq";
import EarthDashboard from "./pages/EarthDashboard";
import { MobileRootRedirect } from "./components/MobileRootRedirect";
import BatteryPassportPage from "./pages/BatteryPassportPage";
import LeaderboardPage from "./pages/LeaderboardPage";
import ReferralLeaderboardPage from "./pages/ReferralLeaderboardPage";
import ScanRedirect from "./components/ScanRedirect";
import AdminWarrantyDB from "./pages/AdminWarrantyDB";
import AdminImpactPage from "./pages/AdminImpactPage";
import LegendaryWallPage from "./pages/LegendaryWallPage";
import WarrantyClaimPage from "./pages/WarrantyClaimPage";
import ImpactPage from "./pages/ImpactPage";
import PartnersPage from "./pages/PartnersPage";

function App() {
  const path = typeof window !== "undefined" ? window.location.pathname : "/";
  const isAdminRoute = path.startsWith("/admin");
  const isAppRoute = path.startsWith("/app");
  const isPassportRoute = path.startsWith("/passport/") || path.startsWith("/p/");
  return (
    <div className="App">
      <BrowserRouter>
        {/* WelcomeGate is opt-in: it only opens when a CTA dispatches
            `eviq:open-welcome-gate` (or the user returns from Stripe).
            It's mounted globally so any CTA on Landing or /app can invoke it. */}
        {!isAdminRoute && !isPassportRoute && <WelcomeGate />}
        {!isAdminRoute && !isAppRoute && !isPassportRoute && <TeslaConnectBanner />}
        <Toaster
          theme="dark"
          position="top-center"
          toastOptions={{
            style: {
              background: "#0a0a0a",
              border: "1px solid rgba(255,255,255,0.1)",
              color: "white",
              fontFamily: "monospace",
              fontSize: "12px",
            },
          }}
        />
        <Routes>
          <Route
            path="/"
            element={
              <MobileRootRedirect>
                <Landing />
              </MobileRootRedirect>
            }
          />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/admin/warranty" element={<AdminWarrantyDB />} />
          <Route path="/admin/impact" element={<AdminImpactPage />} />
          <Route path="/admin/tesla-fleet" element={<AdminTeslaFleet />} />
          <Route
            path="/pricing"
            element={
              <Landing
                seoTitle="EVIQ pricing — from $9.99/month, 7-day free preview"
                seoDescription="EVIQ plans: Basic $9.99/mo, Yearly $99.99 (save 17%), or $199.99 Lifetime covering 5 vehicles. Every plan starts with a 7-day free preview — card required, cancel by email in one line."
                canonical="https://eviq.pro/pricing"
                scrollTo="pricing"
              />
            }
          />
          <Route
            path="/features"
            element={
              <Landing
                seoTitle="EVIQ features — EV battery health, warranty tracking & Battery Passport"
                seoDescription="Live State-of-Health monitoring, degradation forecasting, warranty-threshold tracking, AI battery coach, and a cryptographically signed Digital Battery Passport for Tesla, Ford, and Volvo/Polestar."
                canonical="https://eviq.pro/features"
                scrollTo="features"
              />
            }
          />
          <Route path="/vin" element={<VinLookupPage />} />
          <Route path="/reviews" element={<ReviewsPage />} />
          <Route path="/vs/:competitor" element={<ComparisonPage />} />
          <Route path="/blog" element={<BlogPage />} />
          <Route path="/blog/:slug" element={<BlogPostPage />} />
          <Route path="/admin/blog" element={<AdminBlogPage />} />
          <Route path="/vin/:vin" element={<VinLookupPage />} />
          <Route path="/app" element={<MobileApp />} />
          <Route path="/connect" element={<ConnectPage />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/terms" element={<TermsOfService />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/about" element={<About />} />
          <Route path="/security" element={<Security />} />
          <Route path="/cookies" element={<CookiePolicy />} />
          <Route path="/why-eviq" element={<WhyEviq />} />
          <Route path="/earth" element={<EarthDashboard />} />
          <Route path="/impact" element={<ImpactPage />} />
          <Route path="/partners" element={<PartnersPage />} />
          <Route path="/passport/:id" element={<BatteryPassportPage />} />
          {/* Vanity slug alias — /p/<slug> resolves via slug lookup. */}
          <Route path="/p/:slug" element={<BatteryPassportPage />} />
          <Route path="/leaderboard" element={<LeaderboardPage />} />
          <Route path="/referrers" element={<ReferralLeaderboardPage />} />
          <Route path="/scan" element={<ScanRedirect />} />
          <Route path="/legendary" element={<LegendaryWallPage />} />
          <Route path="/warranty/:id" element={<WarrantyClaimPage />} />
          {/* Catch-all: real 404 page, noindex (server still returns 200 — SPA limit). */}
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
